<template>
  <div class="container upcoming-content home-p-color">

      <h1 class="home-color">{{ $t('ppwcHome.p14') }}</h1>

      <div class="bg_line">
        <div class="el-divider__text is-center"><h2>{{ $t('ppwcHome.p15') }}</h2></div>
      </div>

      <p class="p-margin-bottom">{{ $t('ppwcHome.p16') }}</p>
      <p class="p-margin-bottom">{{ $t('ppwcHome.p17') }}</p>
      <p class="p-margin-bottom">{{ $t('ppwcHome.p18') }}</p>
      <p class="p-margin-bottom">{{ $t('ppwcHome.p19') }}</p>
      <div class="ppwc_video" @mouseenter="videoHover = true" @mouseleave="videoHover = false" @mousemove="toMove()">
        <video
          :poster="'/official/static/video/' + $i18n.locale + '.jpg'"
          id="player"
          playsinline
          loop
          ref="video"
        >
          <source :src="'/official/static/video/PPWC_' + $i18n.locale + '.mp4'" type="video/mp4" />Your browser does not support the video tag.
        </video>
        <div class="operate" v-show="videoHover || !videoPlay">
          <img v-if="!videoPlay && !videoHover" class="animation_effect" src="/official/static/img/ppwc/button_play_animation_effect.png" alt="">

          <img v-if="!videoPlay" class="button_video button_play" @click="toPlay()" src="/official/static/img/ppwc/button_play.png" alt="">
          <img v-else class="button_video button_stop" @click="toStop()" src="/official/static/img/ppwc/button_stop.png" alt="">
        </div>
      </div>

      <div class="bg_line">
        <div class="el-divider__text is-center"><h2>{{ $t('ppwcHome.p31') }}</h2></div>
      </div>
      <div class="ticket_bg">
        <h4 class="home-color">{{ $t('ppwcHome.p67') }}</h4>
        <i18n path="ppwcHome.p68" tag="p" class="p-margin-bottom">
          <template slot="link">
            <a class="home-color" href="mailto:events@pppoker.net">events@pppoker.net</a>
          </template>
        </i18n>
        <p class="p-margin-bottom">{{ $t('ppwcHome.p69') }}</p>
        <i18n path="ppwcHome.p71" tag="p">
          <template slot="link">
            <a class="home-color" href="mailto:events@pppoker.net">events@pppoker.net</a>
          </template>
        </i18n>
      </div>

      <div class="bg_line">
        <div class="el-divider__text is-center"><h2>{{ $t('ppwcHome.p20') }}</h2></div>
      </div>
      <h4>{{ $t('ppwcHome.p21') }}</h4>
      <p class="p-margin-bottom"><img src="/official/static/img/ppwc/spade.png"> {{ $t('ppwcHome.p22') }}</p>

      <h4>{{ $t('ppwcHome.p23') }}</h4>
      <p class="p-margin-bottom"><img src="/official/static/img/ppwc/spade.png"> {{ $t('ppwcHome.p24') }}</p>
      <p class="p-margin-bottom"><img src="/official/static/img/ppwc/spade.png"> {{ $t('ppwcHome.p25') }}</p>
      <p class="p-margin-bottom">{{ $t('ppwcHome.p26') }}</p>
      <br>
      <p style="font-size: 14px;margin-bottom: 10px;color: #8e8e8e;">{{ $t('ppwcHome.p27') }}</p>
      <i18n path="ppwcHome.p28" tag="p" style="font-size: 14px;color: #8e8e8e;">
        <template slot="link">
          <a class="home-color" href="mailto:events@pppoker.net">events@pppoker.net</a>
        </template>
      </i18n>

      <div class="bg_line">
        <div class="el-divider__text is-center"><h2>{{ $t('ppwcHome.p33') }}</h2></div>
      </div>
      <img width="100%" :src="'/official/static/img/ppwc/form_' + $i18n.locale + '_main_event_info.jpg'">
      <a class="p-margin-bottom home-color" target="_blank" href="#/user-agreement-ppwc-braze">{{ $t('ppwcHome.p53') }}</a>

      <div class="bg_line">
        <div class="el-divider__text is-center"><h2>{{ $t('ppwcHome.p54') }}</h2></div>
      </div>
      <a class="map p-margin-bottom" target="_blank" :href="'https://www.google.com/maps/place/Holiday+Inn+Sao+Paulo+Parque+Anhembi/@-23.5166646,-46.6406835,17.25z/data=!4m18!1m9!3m8!1s0x94ce58793768dfd7:0x18fb1addbb3ce745!2sHoliday+Inn+Sao+Paulo+Parque+Anhembi!5m2!4m1!1i2!8m2!3d-23.5166593!4d-46.6388028!3m7!1s0x94ce58793768dfd7:0x18fb1addbb3ce745!5m2!4m1!1i2!8m2!3d-23.5166593!4d-46.6388028?hl=' + $i18n.locale"><img :src="'/official/static/img/events/upcoming/pc_' + $i18n.locale + '.jpg'" alt /></a>
      <p class="p-margin-bottom">{{ $t('ppwcHome.p55') }}</p>

      <div class="bg_line">
        <div class="el-divider__text is-center"><h2>{{ $t('ppwcHome.p56') }}</h2></div>
      </div>
      <p class="p-margin-bottom">{{ $t('ppwcHome.p57') }}</p>

      <div class="bg_line">
        <div class="el-divider__text is-center"><h2>{{ $t('ppwcHome.p65') }}</h2></div>
      </div>
      <p class="p-margin-bottom">{{ $t('ppwcHome.p66') }}</p>
      <div class="center partner_img">
        <a><img src="/official/static/img/ppwc/npt.jpg" class="npt_img" alt=""></a>
        <div class="partner_line"></div>
        <a href="https://www.realpoker.com.br/pppoker/?utm_source=ppwc" target="_blank"><img src="/official/static/img/ppwc/real.jpg" class="real_img" alt=""></a>
      </div>

      <div class="pops" v-if="show">
        <div class="dark" @click="show = false"></div>
        <div class="pop">
          <div class="f-dialog">
            <div class="f-title">
              <div class="f-t-title">
                <p>{{ $t('ppwc.p67') }}</p>
              </div>
            </div>
            <div class="f-content">
              <p>{{ $t('ppwcHome.p61') }}</p>
            </div>
            <div class="f-t-button">
              <div class="f-t-cancel" @click="show = false">
                <p class="home-color">{{ $t('ppwcHome.p62') }}</p>
              </div>
              <div class="f-t-confirm" @click="toActivate">
                <p>{{ $t('ppwcHome.p63') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// import googleMap from './googleMap.vue';

export default {
  data () {
    return {
      show: false,
      videoPlay: false,
      videoHover: false,
      setTime: null
    }
  },
  methods: {
    toMove () {
      if (this.videoPlay) {
        clearTimeout(this.setTime)
        this.videoHover = true
        this.setTime = setTimeout(() => {
          this.videoHover = false
        }, 2000)
      }
    },
    toPlay () {
      document.querySelector('#player').play()
      this.videoPlay = true

      this.setTime = setTimeout(() => {
        this.videoHover = false
      }, 2000)
    },
    toStop () {
      document.querySelector('#player').pause()
      this.videoPlay = false

      clearTimeout(this.setTime)
    },
    toActivate () {
      this.$router.push({ name: 'upcoming-activate', params: { step: 1 } })
    }
  },
  components: {
    // googleMap
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@-webkit-keyframes loader-02 {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
@keyframes loader-02 {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
@-webkit-keyframes button-c {
  0% {
    -webkit-transform: scale(0.95);
    transform: scale(0.95);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes button-c {
  0% {
    -webkit-transform: scale(0.95);
    transform: scale(0.95);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@-webkit-keyframes arrow-head {
  0% {
    -webkit-transform: translateX(0) translateY(0);
    transform: translateX(0) translateY(0);
  }
  100% {
    -webkit-transform: translateX(0) translateY(6px);
    transform: translateX(0) translateY(6px);
  }
}
@keyframes arrow-head {
  0% {
    -webkit-transform: translateX(0) translateY(0);
    transform: translateX(0) translateY(0);
  }
  100% {
    -webkit-transform: translateX(0) translateY(6px);
    transform: translateX(0) translateY(6px);
  }
}

a {
  box-shadow: 0 1PX;
}
.upcoming-content {
  padding-top: 50px;
  padding-bottom: 80px;
  p {
    font-size: 16px;
    line-height: 24px;
  }
  .p-margin-bottom {
    margin-bottom: 20px;
  }
  .picture {
    width: 460px;
  }
  h1 {
    font-size: 40px;
    color: #077594;
    text-align: center;
    margin-top: 0px;
    font-weight: 900;
  }
  h2 {
    font-size: 30px;
    margin: 0px;
    color: #616161;
    max-width: 510px;
    font-weight: 900;
  }
  h4 {
    font-size: 20px;
    margin: 18px 0px;
    line-height: 26px;
  }
  .ppwc_video {
    position: relative;
    width: 100%;
    video {
      width: 100%;
    }
    .operate {
      position: absolute;
      width: 90px;
      height: 90px;
      left: 50%;
      top: 50%;
      margin-left: -45px;
      margin-top: -45px;
      .animation_effect {
        position: absolute;
        width: 78px;
        height: 78px;
        left: 6px;
        top: 6px;
        -webkit-animation: 1s loader-02 linear infinite;
        animation: 1s loader-02 linear infinite;
        cursor: pointer;
      }
      .button_video {
        // position: absolute;
        width: 90px;
        height: 90px;
        // left: 4px;
        // top: 4px;
        cursor: pointer;
      }
    }
  }
  .bg_line {
    background: url('/official/static/img/ppwc/line.jpg') no-repeat center top;
    width: 100%;
    height: 40px;
    margin-top: 94px;
    margin-bottom: 30px;
    position: relative;
    .el-divider__text.is-center {
      top: 18px;
      text-align: center;
    }
  }
  .ticket_bg {
    background: url('/official/static/img/ppwc/ticket_bg.jpg') no-repeat center top;
    background-size: 100%;
    padding: 15px 30px 30px 30px;
  }
  .banner_ticket {
    background: url('/official/static/img/ppwc/banner_ticket.jpg') no-repeat center center;
    background-size: 100%;
    width: 100%;
    height: 188px;
    p, a {
      margin-left: 540px;
    }
    p {
      margin: 0px 0px 6px 540px;
      padding-top: 60px;
      font-size: 22px;
    }
  }
  .button_ticket {
    background: url('/official/static/img/ppwc/button_ticket.png') no-repeat center center;
    background-size: 100%;
    width: 427px;
    height: 76px;
    margin: 0 auto;
    cursor: pointer;
    -webkit-animation: 0.8s linear infinite alternate button-c;
    animation: 0.8s linear infinite alternate button-c;
    position: relative;
    p {
      line-height: 76px;
      text-align: center;
      color: #fff;
      font-size: 28px;
      font-weight: bold;
    }
    .hand {
      position: absolute;
      width: 56px;
      right: 30px;
      bottom: -30px;
    }
  }
  .button_details {
    background: url('/official/static/img/ppwc/details_button.png') no-repeat center center;
    background-size: 100%;
    width: 287px;
    height: 54px;
    display: block;
    position: relative;
    cursor: pointer;
    .arrowhead {
      width: 9px;
      position: absolute;
      display: block;
      left: 19px;
      top: 18px;
      -webkit-animation: 0.8s linear infinite alternate arrow-head;
      animation: 0.8s linear infinite alternate arrow-head;
    }
    p {
      line-height: 60px;
      text-align: center;
      color: #fff;
      font-size: 22px;
      font-weight: bold;
      padding-left: 47px;
    }
  }
  .map {
    display: block;
    img {
      width: 100%;
    }
  }
  .up-cont-top {
    .up-cont-top-logo {
      display: inline-block;
      vertical-align: top;
      margin-top: -6px;
      width: 146px;
    }
    .up-cont-top-div {
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;
      h2 {
        margin: 0px;
        font-size: 28px;
        margin-bottom: 10px;
      }
      p {
        font-size: 18px;
        line-height: 32px;
        // font-weight: bold;
      }
    }
  }
  .el-divider--horizontal {
    margin: 22px 0px;
  }
  .up-activate {
    cursor: pointer;
    margin-bottom: 36px;
    width: 240px;
    height: 38px;
    display: block;
    background: url('/official/static/img/events/upcoming/button.png') no-repeat center center;
    background-size: 100%;
    p {
      color: #fff;
      text-align: center;
      line-height: 32px;
      font-size: 18px;
    }
  }
  .partner_img {
    margin-bottom: 20px;
    a {
      display: inline-block;
      vertical-align: middle;
      margin: 15px 40px;
      .npt_img {
        width: 110px;
        display: inline-block;
      }
      .real_img {
        width: 142px;
        display: inline-block;
      }
    }
    a img {
      webkit-transition: all cubic-bezier(.165,.84,.44,1) .3s;
      -o-transition: all cubic-bezier(.165,.84,.44,1) .3s;
      transition: all cubic-bezier(.165,.84,.44,1) .3s;
      -webkit-transform: scale(1);
      -ms-transform: scale(1);
      transform: scale(1);
    }
    a:hover img {
      -webkit-transform: scale(1.1);
      -ms-transform: scale(1.1);
      transform: scale(1.1);
    }
    .partner_line {
      width: 1PX;
      height: 60px;
      display: inline-block;
      vertical-align: middle;
      background-color: #d9d9d9;
    }
  }

  .pops {
    position: fixed;
    top: 20%;
    left: 50%;
    width: 620px;
    margin-left: -310px;
    z-index: 3000;
    .dark {
      background-color: #000000;
      filter: Alpha(opacity=60);
      -moz-opacity: 0.6;
      opacity: 0.6;
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9;
    }
    .f-dialog {
      width: 100%;
      height: auto;
      z-index: 3500;
      position: relative;

      background: url('/official/static/img/ppwc/pop_ups_bg.png') no-repeat center top;
      background-size: 100% 100%;
      border-radius: 0px;

      padding-bottom: 40px;
      padding-top: 20px;
      .f-t-button {
        margin-top: 30px;
        text-align: center;
        .f-t-cancel {
          position: relative;
          height: 42px;
          width: 238px;
          // background-image: url("/official/static/img/dialog/button.png");
          // background-repeat: no-repeat;
          // background-size: 100% 100%;
          border: 1px solid #077594;
          display: inline-block;
          cursor: pointer;
          p {
            line-height: 42px;
            font-size: 18px;
            text-align: center;
          }
        }
        .f-t-confirm {
          position: relative;
          height: 44px;
          width: 240px;
          margin-left: 20px;
          // background-image: url("/official/static/img/dialog/button.png");
          // background-repeat: no-repeat;
          // background-size: 100% 100%;
          background-color: #077594;
          display: inline-block;
          cursor: pointer;
          p {
            color: #fff;
            line-height: 44px;
            font-size: 18px;
            text-align: center;
          }
        }
      }
      .f-title {
        width: 100%;
        height: 90px;
        position: relative;
        .f-t-title {
          height: 100px;
          width: 100%;
          display: inline-block;
          // display: flex;
          // justify-content: center;
          // align-items: center;
          p {
            font-size: 30px;
            line-height: 90px;
            color: #077594;
            font-weight: bold;
            text-align: center;
          }
        }
      }
      .f-content {
        width: 100%;
        p {
          padding: 0 30px;
          font-size: 16px;
          line-height: 26px;
          color: #727272;
        }
      }
    }
  }
}
</style>
